module.exports = __webpack_public_path__ + "media/images/success-img/layer-1-3d3f770e380dce95e5b80c45d7580e43.png";